<template>
  <section class="p1 subtle">
    <h2 class="mb1 left">Project roles</h2>
    <p class="align-right m0">
      <button
        v-if="roles.length"
        class="invisible-button small-button mt1"
        @click.prevent="isEditing =! isEditing">
        <template v-if="!isEditing">Edit</template>
        <template v-else>Done</template>
      </button>
    </p>
    <div
      v-if="!roles.length && !isEditing"
      class="clear">
      <hr class="mb1 c1 black-border border-width-3 clear">
      <p class="mb2">Create some roles so you can setup your red flags and estimates.</p>
      <a
        href="#roles"
        class="button full-button_mb accent-button"
        @click.prevent="isEditing =! isEditing">Add roles</a>
    </div>
    <lw-table
      v-else
      :type="'lined'"
      :id="'roles'"
      :class="'clear mb0'"
    >
      <tr
        v-for="role in roles"
        :key="role.id">
        <td
          v-if="!isEditing"
          class="display font-size-5 bold smoothing accent-text">{{ role.name }}</td>
        <lw-cell-input
          v-else
          :name="'role_' + role.id"
          :id="'role_' + role.id"
          :type="'text'"
          :align="'left'"
          :placeholder="'e.g. Design'"
          v-model="role.name"
          @input="editRole(role.id, role.name)"
        />
        <td
          v-if="isEditing"
          class="delete vertical-align-middle"><a
            href="#"
            @click.prevent="removeRole(role.id)"><svg-delete/></a></td>
      </tr>
    </lw-table>
    <form
      v-if="isEditing"
      class="flex_sm align-items-flex-end justify-content-space-between"
      @submit.prevent="addRole">
      <lw-text-input
        v-validate.disable="'required'"
        ref="role"
        :id="'role'"
        :label="'New role'"
        :hint="'e.g., Design, Development, Research'"
        :name="'role'"
        :placeholder="'e.g. Design'"
        v-model="name"
        :error="errors.first('role')"
        :class="'pb0 c4x3'"/>
      <div class="mb1"><button
        class="button accent-button right full-button_mb"
        type="submit">Add&nbsp;role</button></div>
    </form>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import * as firebase from 'firebase'
import Table from '../livewires/Table'
import TextInput from '../livewires/TextInput'
import CellInput from '../livewires/CellInput'
import Delete from '../svgs/Delete'

export default {
  components: {
    lwTextInput: TextInput,
    lwCellInput: CellInput,
    lwTable: Table,
    svgDelete: Delete
  },
  data () {
    return {
      name: '',
      isEditing: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'organization'
    ]),
    roles () {
      return this.$store.getters.roles
    }
  },
  methods: {
    addRole () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('saveState', false)
          const updated = firebase.default.firestore.FieldValue.serverTimestamp()
          const payload = {
            name: this.name,
            owner: this.user.id,
            organization: this.organization.id,
            created: updated,
            updated: updated,
            archived: false
          }
          this.$store.dispatch('addRole', payload)
          this.$refs.role.$el.children[0].focus()
          this.name = ''
        }
      })
    },
    editRole (key, name) {
      this.$store.dispatch('saveState', false)
      const payload = {
        id: key,
        name: name,
        updated: firebase.default.firestore.FieldValue.serverTimestamp()
      }
      this.$store.dispatch('editRole', payload)
    },
    removeRole (key) {
      this.$store.dispatch('saveState', false)
      const payload = {
        id: key,
        organization: this.organization.id
      }
      this.$store.dispatch('deleteRole', payload)
    }
  }
}
</script>
